export default "__VITE_ASSET__C$TlMLp9__"